import { render, staticRenderFns } from "./TaskTypeDisplay.vue?vue&type=template&id=051d6935&scoped=true&"
import script from "./TaskTypeDisplay.vue?vue&type=script&lang=js&"
export * from "./TaskTypeDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051d6935",
  null
  
)

export default component.exports